/** The width every choice card in the thread shares, so an approval sits flush with a pick. */
export const CARD_WIDTH = "w-full max-w-[32.5rem]";
/** A card in the thread reaches the screen edges on a phone (the thread keeps a 12px gutter). */
export const THREAD_CARD = `${CARD_WIDTH} max-sm:-mx-3 max-sm:w-auto max-sm:max-w-none`;
